import { render, staticRenderFns } from "./AddTypeModal.vue?vue&type=template&id=949e28ba&scoped=true&"
import script from "./AddTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTypeModal.vue?vue&type=style&index=0&id=949e28ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949e28ba",
  null
  
)

export default component.exports